<script setup>
import QrCode from '@/components/QrCode'
import { ref } from 'vue'

const dialogVisible = ref(false)
const sceneParams = ref({})

const handleDialogClose = () => {
  dialogVisible.value = false
}

defineExpose({
  showDialog: (data) => {
    sceneParams.value = { id: data?.id }
    dialogVisible.value = true
  },
})
</script>
<template>
<el-dialog
  :visible.sync="dialogVisible"
  width="592px"
  @close="handleDialogClose"
  custom-class="followup-dialog"
  :show-close="false"
  :close-on-press-escape="false"
  :close-on-click-modal="false">
  <div class="content">
    <svg-icon icon-class="wechat-oa" class="wechat-oa-icon" />
    <div class="title-wrapper">
      <span class="title">扫码跟进线索</span>
      <span class="sub-title">扫码关注车为家公众号，获取线索更新通知，并在小程序上跟进线索</span>
    </div>
    <div class="qrCode-wrapper">
      <QrCode sceneId="vehicle_clue_follow" :params="sceneParams" v-if="dialogVisible" />
      <div class="tips">
        <span>1.打开微信</span>
        <span class="icon-wrapper">
          <svg-icon icon-class="wid-arrow-right" />
          <svg-icon icon-class="wid-arrow-right" />
        </span>
        <span>2.扫描上方二维码</span>
        <span class="icon-wrapper">
          <svg-icon icon-class="wid-arrow-right" />
          <svg-icon icon-class="wid-arrow-right" />
        </span>
        <span>3.关注车为家服务号</span>
      </div>
    </div>
    <div class="btn-wrapper">
      <el-button type="primary" class="btn" @click="handleDialogClose">
        关闭
      </el-button>
  </div>
  </div>
</el-dialog>
</template>
<style lang="scss" scoped>
::v-deep .followup-dialog {
  border-radius: 16px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    margin: 0;
    padding: 0;
    max-height: fit-content;
  }
}

.content {
  position: relative;
  width: 592px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  gap: 24px;
  border-radius: 16px;
  background: linear-gradient(337deg, #FFFFFF 81%, #E4ECFD 96%);
}

.svg-icon {
  &.wechat-oa-icon {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 80px;
    height: 65.17px;
  }
}


.title-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  gap: 12px;
  .title {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.9);
  }
  .sub-title {
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}

.qrCode-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 20px;
  align-self: stretch;
  border-radius: 12px;
  gap: 20px;
  background: linear-gradient(129deg, #E8F0FD 46%, #EADFFF 124%);
}

.tips {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0;
}

.icon-wrapper {
  display: flex;

  .svg-icon {
    width: 5px;
    height: 7px;
    margin: 0;

    &:first-child {
      opacity: .4;
    }
  }
}

.btn-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn {
  font-weight: 600;
  width: 100%;
  height: 52px;
  border-radius: 12px;
  font-size: 16px;
}
</style>
